import Application from 'src/Application';
import uiConfig from 'src/lib/ui/config';
import { ImageCoverView } from '@play-co/timestep-core/ui';
import ResponsiveScene from './ResponsiveScene';
import { Transition } from 'src/game/logic/SceneManager';

export default class BathroomScene extends ResponsiveScene {
  constructor() {
    super(
      new ImageCoverView({
        ...uiConfig.buruburu.backgroundDefaults,
        ...uiConfig.buruburu.bathroom,
      }),
    );

    this.getView().tag = 'bathroom';

    this.addBath();
  }

  private addBath() {
    const scene = this.getView();
    scene.addSubview(new ImageCoverView(uiConfig.buruburu.bathroomBathTop));
    scene.addSubview(new ImageCoverView(uiConfig.buruburu.bathroomBathFront));
  }

  public transition(): Transition {
    return 'slide_forward';
  }
}
